import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BetSlipEventObj, TProfitBoostItem } from 'interfaces/bet-data';
import { fireToggleProfitBoost } from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import {
  cleanProfitBoostState,
  setProfitBoost as setProfitBoostRedux,
  setSelectedProfitBoostId
} from 'store/actions/betslip';
import {
  getIsProfitBoostAvailable,
  getProfitBoost,
  getProfitBoost_,
  getSelectedProfitBoostItem
} from 'store/selectors/betslip';

type ProfitBoostReturnType = {
  isProfitBoostEnabled: boolean;
  selectedProfitBoostEventId: number | string | undefined | null;
  setSelectedProfitBoostEventId: Function;
  setToggleProfitBoost: Function;
  getSelectedItem: Function;
  setSelectedItem: Function;
  selectedProfitBoostItem: null | TProfitBoostItem | undefined;
  isSingleEventSelected: Function;
  getSelectedAdvancedSingleRule: Function;
  getSelectedAdvancedMultipleRule: Function;
  offAllSelected: () => void;
  showBoostInfo: boolean;
  removeProfitBoostItem: Function;
};

export const useProfitBoost = (): ProfitBoostReturnType => {
  const profitBoost = useSelector(getProfitBoost);
  const selectedProfitBoostItem = useSelector(getSelectedProfitBoostItem);
  const isProfitBoostEnabled = useSelector(getIsProfitBoostAvailable);
  const profitBoostStore = useSelector(getProfitBoost_);

  const dispatch = useDispatch();

  const setToggleProfitBoost = (val = null, eventId: number | null = null) => {
    fireToggleProfitBoost(eventId, val);
  };

  const getSelectedItem = () => selectedProfitBoostItem;

  const setSelectedItem = (id: number) => {
    dispatch(setSelectedProfitBoostId(id));
  };

  const isSingleEventSelected = (
    event: BetSlipEventObj
  ): boolean | undefined => {
    return profitBoostStore.profitBoostSelectedEventId === event.eventId;
  };

  const offAllSelected = () => {
    dispatch(cleanProfitBoostState());
  };

  const removeProfitBoostItem = useCallback(
    (type: string, id: Number) => {
      if (type === 'single' && profitBoost) {
        const profitBoostData = JSON.parse(JSON.stringify(profitBoost));
        profitBoostData.items = profitBoostData.items.map(
          (item: TProfitBoostItem) => item.id !== id
        );
        dispatch(setProfitBoostRedux(profitBoostData));
      }
    },
    [profitBoost]
  );

  return {
    isProfitBoostEnabled,
    selectedProfitBoostEventId: profitBoostStore.profitBoostSelectedEventId,
    setSelectedProfitBoostEventId: (
      eventId: Parameters<typeof setSelectedProfitBoostId>['0']
    ) => dispatch(setSelectedProfitBoostId(eventId)),
    setToggleProfitBoost,
    getSelectedItem,
    setSelectedItem,
    selectedProfitBoostItem,
    isSingleEventSelected,
    getSelectedAdvancedSingleRule: getSelectedItem,
    getSelectedAdvancedMultipleRule: getSelectedItem,
    offAllSelected,
    showBoostInfo:
      !!profitBoostStore.profitBoostSelectedItemId &&
      !!profitBoostStore.profitBoostSelectedEventId,
    removeProfitBoostItem
  };
};
